import { useState } from 'react'
import { Global, ThemeProvider } from '@emotion/react'
import { StylesProvider } from '@material-ui/core/styles'
import { Theme } from './styles/settings'
import { GlobalStyles } from './styles/global'
import Modal from 'react-modal'
import { ModalProvider } from 'react-modal-hook'
import { DataProvider } from './contexts/dataContext'
import NavBar from './components/organisms/NavBar'
import DropDownMenu from './components/molecules/DropDownMenu'
import Intro from './components/pages/Intro'
import Map from './components/pages/Map'

Modal.setAppElement('#root')

function App() {
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <StylesProvider injectFirst>
      <ThemeProvider theme={Theme}>
        <Global styles={GlobalStyles} />
        <DataProvider>
          <ModalProvider>
            <NavBar handleMobileOpen={() => setMobileOpen(!mobileOpen)} />
            <DropDownMenu
              open={mobileOpen}
              handleMobileOpen={() => setMobileOpen(!mobileOpen)}
            />
            <Intro />
            <Map />
          </ModalProvider>
        </DataProvider>
      </ThemeProvider>
    </StylesProvider>
  )
}

export default App
